import { render, staticRenderFns } from "./ExamArea.vue?vue&type=template&id=18a76fa1&scoped=true"
import script from "./ExamArea.vue?vue&type=script&lang=js"
export * from "./ExamArea.vue?vue&type=script&lang=js"
import style0 from "./ExamArea.vue?vue&type=style&index=0&id=18a76fa1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a76fa1",
  null
  
)

export default component.exports